<section id="slider">
    <div class="tp-banner-container">
        <div class="tp-banner">
            <ul>

                <li data-transition="fade" data-slotamount="7" data-masterspeed="2000"
                    data-thumb="../../../assets/images/slider/0052.jpg" data-bgfit="cover" data-delay="5000"
                    data-saveperformance="on" data-title="Ken Burns Slide">
                    <!-- MAIN IMAGE -->
                    <img src="../../../assets/images/dummy.png" alt="laptopmockup_sliderdy"
                        data-lazyload="../../../assets/images/slider/0052.jpg">
                    <!-- LAYERS -->
                    <!--<div class="tp-caption large_bold_white lft tp-resizeme start" data-x="30" data-y="130" data-customin="x:0;y:150;z:0;rotationZ:0;scaleX:1;scaleY:1;skewX:0;skewY:0;opacity:0;transformPerspective:200;transformOrigin:50% 0%;" data-speed="800" data-start="1200" data-easing="easeOutQuad" data-splitin="none" data-splitout="none" data-elementdelay="0.01" data-endelementdelay="0.1" data-endspeed="1000" data-endeasing="Power4.easeIn" style="z-index: 11;">
                        <h1 class="big-title">We <span>Build</span><br> Great Projects</h1>
                    </div>
                    <div class="tp-caption lfl tp-resizeme start" data-x="30" data-y="260" data-customin="x:0;y:150;z:0;rotationZ:0;scaleX:1;scaleY:1;skewX:0;skewY:0;opacity:0;transformPerspective:200;transformOrigin:50% 0%;" data-speed="800" data-start="1600" data-easing="easeOutQuad" data-splitin="none" data-splitout="none" data-elementdelay="0.01" data-endelementdelay="0.1" data-endspeed="1000" data-endeasing="Power4.easeIn" style="z-index: 11;">
                        <p class="small-description">We have the team capable of completing major projects <br> Efficient and high quality</p>
                    </div>-->
                    <div class="tp-caption customin tp-resizeme start" data-x="10" data-y="410"
                        data-customin="x:0;y:150;z:0;rotationZ:0;scaleX:1;scaleY:1;skewX:0;skewY:0;opacity:0;transformPerspective:200;transformOrigin:50% 0%;"
                        data-speed="800" data-start="1800" data-easing="easeOutQuad" data-splitin="none"
                        data-splitout="none" data-elementdelay="0.01" data-endelementdelay="0.1" data-endspeed="1300"
                        data-endeasing="Power4.easeIn" style="z-index: 11;">
                        <a routerLink="/" class="btn btn-large btn-effect">{{'knowMore' | translate}} <i
                                class="icon-arrow-right"></i></a>
                    </div>

                </li>
                <li data-transition="fade" data-slotamount="7" data-masterspeed="2000"
                    data-thumb="../../../assets/images/slider/slide2.jpg" data-bgfit="cover" data-delay="5000"
                    data-saveperformance="on" data-title="Ken Burns Slide">
                    <!-- MAIN IMAGE -->
                    <img src="../../../assets/images/dummy.png" alt="laptopmockup_sliderdy"
                        data-lazyload="../../../assets/images/slider/slide2.jpg">
                    <!-- LAYERS -->
                    <div class="tp-caption ConBiz-medium sfb tp-resizeme start" data-x="30" data-y="130"
                        data-customin="x:0;y:150;z:0;rotationZ:0;scaleX:1;scaleY:1;skewX:0;skewY:0;opacity:0;transformPerspective:200;transformOrigin:50% 0%;"
                        data-speed="800" data-start="1200" data-easing="easeOutQuad" data-splitin="none"
                        data-splitout="none" data-elementdelay="0.01" data-endelementdelay="0.1" data-endspeed="1000"
                        data-endeasing="Power4.easeIn" style="z-index: 11;">
                        <h1 class="big-title">{{'sliderSolgan2' | translate}}<br> {{'sliderSolgan3' | translate}}</h1>
                    </div>
                    <div class="tp-caption ConBiz-medium sfb tp-resizeme start" data-x="30" data-y="260"
                        data-customin="x:0;y:150;z:0;rotationZ:0;scaleX:1;scaleY:1;skewX:0;skewY:0;opacity:0;transformPerspective:200;transformOrigin:50% 0%;"
                        data-speed="800" data-start="1600" data-easing="easeOutQuad" data-splitin="none"
                        data-splitout="none" data-elementdelay="0.01" data-endelementdelay="0.1" data-endspeed="1000"
                        data-endeasing="Power4.easeIn" style="z-index: 11;">
                        <p class="small-description">{{'sliderDes2' | translate}} <br /> {{'sliderDes3' | translate}}</p>
                    </div>
                    <div class="tp-caption ConBiz-medium sfb tp-resizeme start" data-x="30" data-y="320"
                        data-customin="x:0;y:150;z:0;rotationZ:0;scaleX:1;scaleY:1;skewX:0;skewY:0;opacity:0;transformPerspective:200;transformOrigin:50% 0%;"
                        data-speed="800" data-start="1800" data-easing="easeOutQuad" data-splitin="none"
                        data-splitout="none" data-elementdelay="0.01" data-endelementdelay="0.1" data-endspeed="1300"
                        data-endeasing="Power4.easeIn" style="z-index: 11;">
                        <a routerLink="/Contact" class="btn btn-large btn-effect">{{'contactus' | translate}} <i
                                class="icon-envelope"></i></a>
                    </div>
                    <!-- LAYER NR. 2 -->
                    <div class="tp-caption lfb start" data-y="50" data-x="750"
                        style="z-index: 9; left: 839.5px; top: 125px; visibility: visible; opacity: 0; transform: translate3d(0px, 763px, 0px);"
                        data-captionhidden="on" data-endeasing="Power4.easeIn" data-endspeed="1000" data-start="1200"
                        data-speed="800"
                        data-customout="x:0;y:0;z:0;rotationX:0;rotationY:0;rotationZ:0;scaleX:0.75;scaleY:0.75;skewX:0;skewY:0;opacity:0;transformPerspective:600;transformOrigin:50% 50%;">
                        <img src="../../../assets/images/dummy.png" alt=""
                            data-lazyload="../../../assets/images/slider/3dlayer_3.png">
                    </div>
                </li>
                <li data-transition="fade" data-slotamount="7" data-masterspeed="2000"
                    data-thumb="../../../assets/images/slider/slide3.jpg" data-bgfit="cover" data-delay="5000"
                    data-saveperformance="on" data-title="Ken Burns Slide">
                    <!-- MAIN IMAGE -->
                    <img src="../../../assets/images/dummy.png" alt="laptopmockup_sliderdy"
                        data-lazyload="../../../assets/images/slider/slide3.jpg">
                    <!-- LAYERS -->
                    <div class="tp-caption large_bold_white tp-resizeme lft start" data-x="center" data-hoffset="0"
                        data-y="center" data-voffset="-60"
                        data-customin="x:0;y:150;z:0;rotationZ:0;scaleX:1;scaleY:1;skewX:0;skewY:0;opacity:0;transformPerspective:200;transformOrigin:50% 0%;"
                        data-speed="800" data-start="1600" data-easing="easeOutQuad" data-splitin="none"
                        data-splitout="none" data-elementdelay="0.01" data-endelementdelay="0.1" data-endspeed="1000"
                        data-endeasing="Power4.easeIn" style="z-index: 11;">
                        <h1 class="big-title">
                            {{'sliderSlogan1' | translate}}
                        </h1>
                    </div>
                    <div class="tp-caption tp-resizeme start" data-x="center" data-hoffset="0" data-y="center"
                        data-voffset="0"
                        style="z-index: 14; min-height: 0px; min-width: 0px; line-height: 25px; border-width: 0px; margin: 0px; padding: 0px; letter-spacing: 0px; font-size: 18px; left: 259.5px; top: 340px; visibility: visible; opacity: 0; transform: translate3d(0px, 0px, 0px);"
                        data-endeasing="Back.easeIn" data-endspeed="400" data-start="1500" data-speed="1000"
                        data-customin="x:0;y:0;z:0;rotationX:90;rotationY:0;rotationZ:0;scaleX:1;scaleY:1;skewX:0;skewY:0;opacity:0;transformPerspective:200;transformOrigin:50% 0%;">
                        <p class="small-description"> {{'sliderDes1' | translate}} </p>
                    </div>

                    <div class="tp-caption customin tp-resizeme lfb start" data-x="center" data-hoffset="0"
                        data-y="center" data-voffset="60"
                        data-customin="x:0;y:150;z:0;rotationZ:0;scaleX:1;scaleY:1;skewX:0;skewY:0;opacity:0;transformPerspective:200;transformOrigin:50% 0%;"
                        data-speed="800" data-start="1800" data-easing="easeOutQuad" data-splitin="none"
                        data-splitout="none" data-elementdelay="0.01" data-endelementdelay="0.1" data-endspeed="1300"
                        data-endeasing="Power4.easeIn" style="z-index: 11;"><a routerLink="/Quote"
                            class="btn btn-large btn-effect">{{'startNow' | translate}}</a></div>
                </li>
            </ul>
            <div class="tp-bannertimer"></div>
        </div>
    </div>
</section>

<!-- Start Boxed Section -->
<div class="boxed">
    <div class="container">
        <div class="row">
            <div class="col-md-8 col-sm-8 float-r">
                <h5 style="color:white">{{'ready' | translate}}</h5>
            </div>
            <div class="col-md-4 col-sm-4">
                <a routerLink="/Quote" class="btn btn-border  float-l" style="font-size:x-small ;font-weight:bold">{{'qouet' | translate}}</a>
            </div>
        </div>
    </div>
</div>
<!-- End Boxed Section -->


<!-- Start Service Section -->
<a id="ProjectSection">
</a>
<div class="service section">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-4 col-xl-12">
                <div class="service-box">
                    <div class="service-head">
                        <a class="icon">
                            <i class="icon-user"></i>
                        </a>
                        <h2>PM</h2>
                        <p class="desc">{{'pm' | translate}}</p>
                    </div>
                    <div class="service-content">
                        <p> {{'pmDes' | translate}}</p>
                        <a routerLink="/" class="btn btn-effect">{{'readMore' | translate}} <i class="icon-arrow-right"></i></a>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-4 col-xl-12">
                <div class="service-box">
                    <div class="service-head">
                        <a class="icon">
                            <i class="icon-graph"></i>
                        </a>
                        <h2>ERP</h2>
                        <p class="desc">{{'ERP' | translate}}</p>
                    </div>
                    <div class="service-content">
                        <p>{{'ERPDes' | translate}}<br /><br /> </p>
                        <a routerLink="/" class="btn btn-effect">{{'readMore' | translate}} <i class="icon-arrow-right"></i></a>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-4 col-xl-12">
                <div class="service-box">
                    <div class="service-head">
                        <a class="icon">
                            <i class="icon-map"></i>
                        </a>
                        <h2>GIS</h2>
                        <p class="desc">{{'GIS' | translate}}</p>
                    </div>
                    <div class="service-content">
                        <p>{{'GISDes' | translate}}<br /><br /><br /></p>
                        <a routerLink="/" class="btn btn-effect">{{'readMore' | translate}} <i class="icon-arrow-right"></i></a>
                    </div>
                </div>
            </div>

        </div>
        
        <div class="row" style="margin-top: 70px;">
            <div class="col-lg-4 col-md-6 col-sm-4 col-xl-12 float-r">
                <div class="service-box">
                    <div class="service-head">
                        <a class="icon">
                            <i class="icon-notebook"></i>
                        </a>
                        <h2>{{'LearnyhomeTitle' | translate}}</h2>
                        <p class="desc">{{'learnyhome' | translate}}</p>
                    </div>
                    <div class="service-content">
                        <p> {{'learnyhomeDes' | translate}}</p>
                        <a href="https://learnyhome.com/Home" class="btn btn-effect">{{'readMore' | translate}} <i class="icon-arrow-right"></i></a>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-4 col-xl-12 float-r">
                <div class="service-box">
                    <div class="service-head">
                        <a class="icon">
                            <i class="icon-calculator"></i>
                        </a>
                        <h2>{{'fawateernaTitle' | translate}}</h2>
                        <p class="desc">{{'fawateerna' | translate}}</p>
                    </div>
                    <div class="service-content">
                        <p>{{'fawateernaDes' | translate}}<br /><br /> </p>
                        <a href="https://fawateerna.com/home" class="btn btn-effect">{{'readMore' | translate}} <i class="icon-arrow-right"></i></a>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-4 col-xl-12 float-r">
                <div class="service-box">
                    <div class="service-head">
                        <a class="icon">
                            <i class="icon-book-open"></i>
                        </a>
                        <h2>{{'4sigingTitle' | translate}}</h2>
                        <p class="desc">{{'4sign' | translate}}</p>
                    </div>
                    <div class="service-content">
                        <p>{{'4signDes' | translate}}<br /><br /> </p>
                        <a href="https://4signing.com/#/home" class="btn btn-effect">{{'readMore' | translate}} <i class="icon-arrow-right"></i></a>
                    </div>
                </div>
            </div>

        </div>
        <!-- .row -->
    </div>
    <!-- .container -->
</div>
<!-- End Service Section -->

<!-- Start Featured Section -->
<div class="featured section">
    <div class="container">
        <div class="row">
            <div class="col-md-6 col-sm-6 col-xl-12 float-r">
                <div class="row">
                    <div class="col-md-6 featured-content">
                        <div class="featured-header">
                            <i class="icon-bulb"></i>
                            <div class="featured-title">
                                <h4><a routerLink="/">{{'InnovativeIdeas' | translate}}</a></h4>
                                <p>{{'InnovativeIdeasSub' | translate}}</p>
                            </div>
                        </div>
                        <p>{{'InnovativeIdeasDes' | translate}}</p>
                    </div>
                    <div class="col-md-6 featured-content">
                        <div class="featured-header">
                            <i class="icon-magnifier"></i>
                            <div class="featured-title">
                                <h4><a routerLink="/">{{'DetailResearches' | translate}}</a></h4>
                                <p>{{'DetailResearchesSub' | translate}}</p>
                            </div>
                        </div>
                        <p>{{'DetailResearchesDes' | translate}}</p>
                    </div>
                    <div class="col-md-6 featured-content">
                        <div class="featured-header">
                            <i class="icon-shuffle"></i>
                            <div class="featured-title">
                                <h4><a routerLink="/">{{'OrganizedWorkflows' | translate}}</a></h4>
                                <p>{{'OrganizedWorkflowsSub' | translate}} </p>
                            </div>
                        </div>
                        <p>{{'OrganizedWorkflowsDes' | translate}}</p>
                    </div>
                    <div class="col-md-6 featured-content">
                        <div class="featured-header">
                            <i class="icon-wrench"></i>
                            <div class="featured-title">
                                <h4><a routerLink="/">{{'LatestTechnologies' | translate}}</a></h4>
                                <p>{{'LatestTechnologiesSub' | translate}}</p>
                            </div>
                        </div>
                        <p>{{'LatestTechnologiesDes' | translate}}</p>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-sm-6 col-xl-12">
                <div class="featured-thumb" id="yourElement">
                    <img class="img-en" src="../../../assets/images/goals.png" alt="">
                    <img class="img-ar float-l" src="../../../assets/images/GoalsArabic.png" alt="">
                </div>
            </div>
        </div>
    </div>
</div>

<!-- End Featured Section -->
<!-- Start Team Member Section -->
<!-- <div class="team section">
    <div class="container">
        <div class="heading">
            <div class="section-title"><a routerLink="/Team">{{'Team' | translate}} <span>{{'Members' | translate}}</span></a></div>
        </div>
        <p class="description text-center">{{'TeamDes' | translate}}
        </p>
        <div class="row">
            <div class="col-md-3 col-sm-6">
                <div class="team-member">
                    <div class="team-thumbnail">
                        <img src="../../../assets/images/team/eng-zuhair.jpg" alt="">
                        <div class="overlay">
                            <p class="text"></p>
                            <div class="info name">
                                <h4>{{'T1' | translate}}</h4>
                                <p>{{'T1D' | translate}}</p>
                            </div>
                            <div class="social-media">
                                <a href="https://www.facebook.com/engzuhair68?fref=ts" class="facebook"><i
                                        class="fa fa-facebook"></i></a>

                                <a href="https://sa.linkedin.com/in/zuhair-wanli-5515a6102/en" class="linkedin"><i
                                        class="fa fa-linkedin"></i></a>
                            </div>
                        </div>
                    </div>
                    <div class="info">
                        <h4>{{'T1' | translate}}</h4>
                        <p>{{'T1D' | translate}}</p>
                    </div>
                </div>
            </div>
            <div class="col-md-3 col-sm-6">
                <div class="team-member">
                    <div class="team-thumbnail">
                        <img height="100" src="../../../assets/images/team/Tonsy1png.png" alt="">
                        <div class="overlay">
                            <p class="text"></p>
                            <div class="info name">
                                <h4>{{'T2' | translate}}</h4>
                                <p>{{'T2D' | translate}}</p>
                            </div>
                            <div class="social-media">
                                <a href="https://www.facebook.com/tunisation" class="facebook"><i
                                        class="fa fa-facebook"></i></a>
                                <a href="https://twitter.com/#" class="twitter"><i class="fa fa-twitter"></i></a>
                                <a href="https://plus.google.com/+tunisation" class="google"><i
                                        class="fa fa-google-plus"></i></a>
                                <a href="https://eg.linkedin.com/in/tunisation" class="linkedin"><i
                                        class="fa fa-linkedin"></i></a>
                            </div>
                        </div>
                    </div>
                    <div class="info">
                        <h4>{{'T2' | translate}}</h4>
                        <p>{{'T2D' | translate}}</p>
                    </div>
                </div>
            </div>
            <div class="col-md-3 col-sm-6">
                <div class="team-member">
                    <div class="team-thumbnail">
                        <img src="../../../assets/images/team/Ahmed1.png" alt="">
                        <div class="overlay">
                            <p class="text"></p>
                            <div class="info name">
                                <h4>{{'T3' | translate}}</h4>
                                <p>{{'T3D' | translate}}</p>
                            </div>
                            <div class="social-media">
                                <a href="https://www.facebook.com/goharyone?fref=ts" class="facebook"><i
                                        class="fa fa-facebook"></i></a>
                                <a href="https://twitter.com/goharyone" class="twitter"><i
                                        class="fa fa-twitter"></i></a>
                                <a href="https://plus.google.com/u/0/105524579950788841990" class="google"><i
                                        class="fa fa-google-plus"></i></a>
                                <a href="https://eg.linkedin.com/in/ahmed-gohary-25666951" class="linkedin"><i
                                        class="fa fa-linkedin"></i></a>
                            </div>
                        </div>
                    </div>
                    <div class="info">
                        <h4>{{'T3' | translate}}</h4>
                        <p>{{'T3D' | translate}}</p>
                    </div>
                </div>
            </div>
            <div class="col-md-3 col-sm-6">
                <div class="team-member">
                    <div class="team-thumbnail">
                        <img src="../../../assets/images/team/zaki.png" alt="">
                        <div class="overlay">
                            <p class="text"></p>
                            <div class="info name">
                                <h4>{{'T4' | translate}}</h4>
                                <p>{{'T4D' | translate}} </p>
                            </div>
                            <div class="social-media">
                                <a href="https://www.facebook.com/zaki.eldsoque" class="facebook"><i
                                        class="fa fa-facebook"></i></a>
                                <a href="https://twitter.com/zeko_Eldsoque" class="twitter"><i
                                        class="fa fa-twitter"></i></a>
                                <a href="https://plus.google.com/+ZakiEldsoque" class="google"><i
                                        class="fa fa-google-plus"></i></a>
                                <a href="https://eg.linkedin.com/in/zakieldsoque" class="linkedin"><i
                                        class="fa fa-linkedin"></i></a>
                            </div>
                        </div>
                    </div>
                    <div class="info">
                        <h4>{{'T4' | translate}}</h4>
                        <p>{{'T4D' | translate}}</p>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div> -->


<!-- Start Team Member Section -->
<!-- Start Counter Section -->
<div id="counter" class="section" style="margin-bottom:0.1%">
    <div class="container">
        <div class="row">
            <div class="col-xs-12 col-sm-6 col-md-3">
                <div class="counter-item left-line">
                    <div class="icon">
                        <i class="icon-check">
                        </i>
                    </div>
                    <h5>
                        {{'CompletedProjects' | translate}}
                    </h5>
                    <hr>
                    <div class="timer" data-to="180" data-speed="5000">
                    </div>
                </div>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-3">
                <div class="counter-item">
                    <div class="icon">
                        <i class="icon-clock">
                        </i>
                    </div>
                    <h5>
                        {{'HoursofWork' | translate}} <span>{{'Month' | translate}}</span>
                    </h5>
                    <hr>
                    <div class="timer" data-to="369" data-speed="5000">
                    </div>
                </div>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-3">
                <div class="counter-item">
                    <div class="icon">
                        <i class="icon-trophy">
                        </i>
                    </div>
                    <h5>
                        {{'AwardWinnigs' | translate}}
                    </h5>
                    <hr>
                    <div class="timer" data-to="29" data-speed="5000">
                    </div>
                </div>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-3">
                <div class="counter-item">
                    <div class="icon">
                        <i class="icon-heart">
                        </i>
                    </div>
                    <h5>
                        {{'SatisfiedClients' | translate}}
                    </h5>
                    <hr>
                    <div class="timer" data-to="149" data-speed="5000">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<!-- Testimonial Section End -->
<!-- Start Client Section -->
<div class="client section">
    <div class="container">
        <!-- Start Heading -->
        <div class="heading">
            <div class="section-title">{{'Partners' | translate}} <span>{{'Clients' | translate}}</span></div>
        </div>
        <!-- End Heading -->
        <!-- Some Text -->
        <p class="description text-center">{{'PartnersDes' | translate}}
        </p>
        <div class="row">
            <div id="client-logo" class="touch-carousel">
                <div class="client-logo item">
                    <div class="client-item">
                        <a routerLink="/">
                            <img src="../../../assets/images/clients/logo-01.png" alt="" />
                        </a>
                    </div>
                </div>
                <div class="client-logo item">
                    <div class="client-item">
                        <a routerLink="/">
                            <img src="../../../assets/images/clients/logo-02.png" alt="" />
                        </a>
                    </div>
                </div>
                <div class="client-logo item">
                    <div class="client-item">
                        <a routerLink="/">
                            <img src="../../../assets/images/clients/logo-07.png" alt="" />
                        </a>
                    </div>
                </div>
                <div class="client-logo item">
                    <div class="client-item">
                        <a routerLink="/">
                            <img src="../../../assets/images/clients/logo-09.png" alt="" />
                        </a>
                    </div>
                </div>
                <div class="client-logo item">
                    <div class="client-item">
                        <a routerLink="/">
                            <img src="../../../assets/images/clients/logo-10.png" alt="" />
                        </a>
                    </div>
                </div>
                <div class="client-logo item">
                    <div class="client-item">
                        <a routerLink="/">
                            <img src="../../../assets/images/clients/logo-12.png" alt="" />
                        </a>
                    </div>
                </div>
                <div class="client-logo item">
                    <div class="client-item">
                        <a routerLink="/">
                            <img src="../../../assets/images/clients/logo-13.png" alt="" />
                        </a>
                    </div>
                </div>
                <div class="client-logo item">
                    <div class="client-item">
                        <a routerLink="/">
                            <img src="../../../assets/images/clients/logo-08.png" alt="" />
                        </a>
                    </div>
                </div>
                <div class="client-logo item">
                    <div class="client-item">
                        <a routerLink="/">
                            <img src="../../../assets/images/clients/logo-04.png" alt="" />
                        </a>
                    </div>
                </div>

                <div class="client-logo item">
                    <div class="client-item">
                        <a routerLink="/">
                            <img src="../../../assets/images/clients/logo-11.png" alt="" />
                        </a>
                    </div>
                </div>
                <div class="client-logo item">
                    <div class="client-item">
                        <a routerLink="/">
                            <img src="../../../assets/images/clients/logo-05.png" alt="" />
                        </a>
                    </div>
                </div>
                <div class="client-logo item">
                    <div class="client-item">
                        <a routerLink="/">
                            <img src="../../../assets/images/clients/logo-06.png" alt="" />
                        </a>
                    </div>
                </div>
                <div class="client-logo item">
                    <div class="client-item">
                        <a routerLink="/">
                            <img src="../../../assets/images/clients/logo-03.png" alt="" />
                        </a>
                    </div>
                </div>

                <div class="client-logo item">
                    <div class="client-item">
                        <a routerLink="/">
                            <img src="../../../assets/images/clients/amana.ico" alt="" />
                        </a>
                    </div>
                </div>

                <div class="client-logo item">
                    <div class="client-item">
                        <a routerLink="/">
                            <img src="../../../assets/images/clients/logo-100.png" alt="" />
                        </a>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</div>